const ErrorIcon = ({ height, width }: { height: number; width: number }) => (
  <div style={{ height: `${height}px`, width: `${width}px`, padding: "2px" }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_20916_1035)">
        <path
          d="M10 11.4V5.4M10 14.5V14.4M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z"
          stroke="#C60000"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_20916_1035">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </div>
);

export default ErrorIcon;
